import { EventType, InteractionType } from '@azure/msal-browser';
import type { AuthenticationResult, AuthError } from '@azure/msal-browser';

import { forgotPasswordRequest, loginRequest, msalInstance, b2cPolicies } from './config';

export interface InitializeConfiguration {
  onLoginSuccess?: () => void;
}

export const initializeAuth = async (config?: InitializeConfiguration) => {
  const { onLoginSuccess } = config ?? {};

  return msalInstance.initialize().then(() => {
    msalInstance.addEventCallback(event => {
      if (event.eventType === EventType.LOGIN_SUCCESS) {
        if (event.interactionType === InteractionType.Redirect && event.payload) {
          const payload = event.payload as AuthenticationResult;

          if (compareIssuingPolicy(payload.idTokenClaims, b2cPolicies.names.signIn)) {
            const accounts = msalInstance.getAllAccounts();

            if (accounts.length > 0) {
              msalInstance.setActiveAccount(accounts[0]);
            }

            if (onLoginSuccess) {
              onLoginSuccess();
            }
          }

          if (compareIssuingPolicy(payload.idTokenClaims, b2cPolicies.names.forgotPassword)) {
            msalInstance.logoutRedirect();
          }
        }
      }

      if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
        if (event.interactionType === InteractionType.Silent) {
          msalInstance.logoutRedirect();
        }
      }

      if (event.eventType === EventType.LOGIN_FAILURE) {
        if (event.error && (event.error as AuthError)?.errorMessage.indexOf('AADB2C90091') > -1) {
          if (event.interactionType === InteractionType.Redirect) {
            msalInstance.loginRedirect(loginRequest);
            return;
          }
        }
        if (event.error && (event.error as AuthError)?.errorMessage.indexOf('AADB2C') > -1) {
          if (event.interactionType === InteractionType.Redirect) {
            msalInstance.loginRedirect({
              ...loginRequest,
              ...forgotPasswordRequest
            });
          }
        }
        if (event.error && (event.error as AuthError)?.errorMessage.indexOf('No cached authority found') > -1) {
          if (event.interactionType === InteractionType.Redirect) {
            window.location.reload();
          }
        }
      }
    });
  });
};

function compareIssuingPolicy(idTokenClaims: object, policyToCompare: string) {
  const tfpMatches =
    Object.prototype.hasOwnProperty.call(idTokenClaims, 'tfp') &&
    idTokenClaims['tfp'].toLowerCase() === policyToCompare.toLowerCase();
  const acrMatches =
    Object.prototype.hasOwnProperty.call(idTokenClaims, 'acr') &&
    idTokenClaims['acr'].toLowerCase() === policyToCompare.toLowerCase();

  return tfpMatches || acrMatches;
}
